module.exports = new __parcel__URL__("Ecoflex_2_Return_Label.40921cfc.png").toString();